export const iconFontAwesomeMusicVideoNapster = (
	<i className="fa-solid fa-napster"></i>
);
